import React from "react";
import {
  Zap,
  ChevronUp,
  ChevronDown,
  Award,
  Triangle,
  DollarSign,
  TrendingUp,
  PieChart,
} from "lucide-react";

const ScreenerPresets = ({
  expandedSection,
  toggleSection,
  handleFilterChange,
  setExpandedSection,
  setToast,
}) => {
  return (
    <div className="insights-section">
      <div
        className="section-header clickable"
        onClick={() => toggleSection("screenerPresets")}
      >
        <h3>
          <Zap size={20} />
          Value Screener Presets
        </h3>
        <div className="section-toggle">
          {expandedSection === "screenerPresets" ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          )}
        </div>
      </div>

      {expandedSection === "screenerPresets" && (
        <div className="section-content">
          <div className="presets-container">
            <div
              className="preset-card"
              onClick={() => {
                handleFilterChange("discountRange", [30, 90]);
                handleFilterChange("marketCap", "all");
                handleFilterChange("minROIC", 10);
                handleFilterChange("minMargin", 15);
                setExpandedSection("valueStocks");
                setToast({
                  type: "success",
                  message: "Quality Value Preset",
                  subText:
                    "Filters applied: 30%+ discount, 10%+ ROIC, 15%+ margin",
                });
              }}
            >
              <Award size={24} className="preset-icon" />
              <h4>Quality Value</h4>
              <p>
                High-quality companies trading at significant discounts to
                intrinsic value
              </p>
              <ul className="preset-criteria">
                <li>30%+ discount to intrinsic value</li>
                <li>10%+ Return on Invested Capital</li>
                <li>15%+ Operating Margin</li>
                <li>Low Debt-to-Equity ratio</li>
              </ul>
            </div>

            <div
              className="preset-card"
              onClick={() => {
                handleFilterChange("discountRange", [25, 90]);
                handleFilterChange("marketCap", "small");
                handleFilterChange("minROIC", 8);
                handleFilterChange("minMargin", 12);
                setExpandedSection("valueStocks");
                setToast({
                  type: "success",
                  message: "Small Cap Value Preset",
                  subText:
                    "Filters applied: Small caps, 25%+ discount, 8%+ ROIC",
                });
              }}
            >
              <Triangle size={24} className="preset-icon" />
              <h4>Small Cap Value</h4>
              <p>Smaller companies with strong fundamentals at a discount</p>
              <ul className="preset-criteria">
                <li>Small cap companies (&lt;$2B)</li>
                <li>25%+ discount to intrinsic value</li>
                <li>8%+ Return on Invested Capital</li>
                <li>12%+ Operating Margin</li>
              </ul>
            </div>

            <div
              className="preset-card"
              onClick={() => {
                handleFilterChange("discountRange", [15, 90]);
                handleFilterChange("marketCap", "large");
                handleFilterChange("minROIC", 15);
                handleFilterChange("minMargin", 20);
                handleFilterChange("sector", "Technology");
                setExpandedSection("valueStocks");
                setToast({
                  type: "success",
                  message: "Tech Value Preset",
                  subText:
                    "Filters applied: Tech sector, 15%+ discount, 15%+ ROIC",
                });
              }}
            >
              <Zap size={24} className="preset-icon" />
              <h4>Tech Value</h4>
              <p>
                Technology companies with strong economics at reasonable prices
              </p>
              <ul className="preset-criteria">
                <li>Technology sector</li>
                <li>15%+ discount to intrinsic value</li>
                <li>15%+ Return on Invested Capital</li>
                <li>20%+ Operating Margin</li>
              </ul>
            </div>

            <div
              className="preset-card"
              onClick={() => {
                handleFilterChange("discountRange", [15, 90]);
                handleFilterChange("marketCap", "all");
                handleFilterChange("minROIC", 5);
                handleFilterChange("minMargin", 10);
                handleFilterChange("sector", "Financial");
                setExpandedSection("valueStocks");
                setToast({
                  type: "success",
                  message: "Financial Value Preset",
                  subText: "Filters applied: Financial sector, 15%+ discount",
                });
              }}
            >
              <DollarSign size={24} className="preset-icon" />
              <h4>Financial Value</h4>
              <p>Financial companies trading below intrinsic value</p>
              <ul className="preset-criteria">
                <li>Financial sector</li>
                <li>15%+ discount to intrinsic value</li>
                <li>5%+ Return on Invested Capital</li>
                <li>10%+ Operating Margin</li>
              </ul>
            </div>

            <div
              className="preset-card"
              onClick={() => {
                handleFilterChange("discountRange", [20, 90]);
                handleFilterChange("marketCap", "all");
                handleFilterChange("minROIC", 12);
                handleFilterChange("minMargin", 15);
                handleFilterChange("sortBy", "growth");
                setExpandedSection("valueStocks");
                setToast({
                  type: "success",
                  message: "Growth at Value Preset",
                  subText:
                    "Filters applied: 20%+ discount, sorted by growth rate",
                });
              }}
            >
              <TrendingUp size={24} className="preset-icon" />
              <h4>Growth at Value</h4>
              <p>Growth companies temporarily trading at value prices</p>
              <ul className="preset-criteria">
                <li>20%+ discount to intrinsic value</li>
                <li>12%+ Return on Invested Capital</li>
                <li>15%+ Operating Margin</li>
                <li>Sorted by Growth Rate</li>
              </ul>
            </div>

            <div
              className="preset-card"
              onClick={() => {
                handleFilterChange("discountRange", [10, 90]);
                handleFilterChange("marketCap", "all");
                handleFilterChange("minROIC", 0);
                handleFilterChange("minMargin", 0);
                handleFilterChange("sortBy", "discount");
                setExpandedSection("valueStocks");
                setToast({
                  type: "success",
                  message: "All Value Opportunities",
                  subText:
                    "Filters applied: 10%+ discount, no other restrictions",
                });
              }}
            >
              <PieChart size={24} className="preset-icon" />
              <h4>All Value Opportunities</h4>
              <p>All companies trading below intrinsic value</p>
              <ul className="preset-criteria">
                <li>10%+ discount to intrinsic value</li>
                <li>Any market cap</li>
                <li>Any sector</li>
                <li>Sorted by largest discount</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScreenerPresets;
